@if (isBusinessDashboard() || isWellbeingDashboard()) {
  <router-outlet></router-outlet>
} @else {
  @if (showHeader()) {
    <app-web-nav></app-web-nav>
  }
  <div class="m-body">
    <router-outlet></router-outlet>
  </div>
  @if (showFooter()) {
    <app-web-footer></app-web-footer>
  }
}
<app-snackbar></app-snackbar>
